import { get, post, del } from "../api_helper"
import { getApiConfig } from "../authHelper"

const ADMIN_WHATSAPP = "/admin-whatsapp"

export const setupAdminWhatsapp = () => post(`${ADMIN_WHATSAPP}/setup`, {}, getApiConfig())
export const getAdminWhatsappStatus = () => get(`${ADMIN_WHATSAPP}/status`, getApiConfig())
export const disconnectAdminWhatsapp = () => del(`${ADMIN_WHATSAPP}/disconnect`, getApiConfig())
